<template>
  <div>
    <boton-atras :nombre_ruta="'informesSHaciendaConac'"/>
    <section class="informacion-consolidada">
      <div class="container text-center mb-5">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Información Consolidada</h1>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <search-vue class="w-10" :data="data" @datos="datosRespuesta = $event" /> <!--{{ datosRespuesta.length }}-->
      </div>
      <table class="styled-table">
        <tbody>
          <tr>
            <td>
              <ul>
                <li  v-for="(contenido, index) in datosRespuesta" :key="index">
                  <div class="contenido-fila">
                    <!-- Mostrar título -->
                    <span class="contenido-titulo">{{ contenido.titulo }}</span>

                    <!-- Contenedor para los íconos -->
                    <div class="iconos-contenedor">
                      <a v-if="contenido.url_pdf" :href="urlServe + contenido.url_pdf" target="_blank">
                        <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                      </a>
                      <a v-if="contenido.url_word" :href="urlServe + contenido.url_word" target="_blank">
                        <i class="fas fa-file-word icono-archivo icon-word"></i>
                      </a>
                      <a v-if="contenido.url_excel" :href="urlServe + contenido.url_excel" target="_blank">
                        <i class="fas fa-file-excel icono-archivo icon-excel"></i>
                      </a>
                      <a v-if="contenido.url_comprimido" :href="urlServe + contenido.url_comprimido" target="_blank">
                        <i class="fas fa-file-archive icono-archivo icon-rar"></i>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <span v-if="datosRespuesta" v-html="DateFormatText(fecha_actualizacion_externa)"></span>
    </section>
  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import ArmonizacionContable from "@/services/ArmonizacionContable/ArmonizacionContable.service.js";
const _serviciosArmonizacionContable = new ArmonizacionContable();
import botonAtras from '../../button-atras'
import('@/assets/css/tablaTypeFiles.css');
import searchVue from '@/components/search.vue'
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
    name: 'InformacionConsolidada',
    components: { botonAtras, searchVue },
    mixins: [DateFormat],
    data() {
        return {
          data: [],
          datosRespuesta: [],
          fecha_actualizacion_externa: '',
        };
    },
    async created() {
        await this.getInformacionConsolidada();
    },
    methods: {
        async getInformacionConsolidada() {
            try {
                const response = await _serviciosArmonizacionContable.getInformacionConsolidada(mapFun.informacionConsolidada);
                this.data = response.data[0];
                this.fecha_actualizacion_externa = this.data.fecha_actualizacion;
                this.data = this.data.contenido;
            } catch (error) {
                console.log('error', error.message);
            }
        }
    },
    watch:{}
}
</script>
